import { inject, Injectable, Injector } from '@angular/core';
import { Router, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PageTitleService } from './page-title.service';
import { currentNavId } from './current-nav-id';

/**
 * Feeds the activated route's `title` into {@link PageTitleService} instead of writing the
 * document title directly, so detail pages can override it without the two fighting.
 *
 * Route titles are translation keys (`title: 'WAREHOUSE_RECEIPTS'`), resolved downstream so a
 * language switch re-renders them.
 */
@Injectable()
export class RcTitleStrategy extends TitleStrategy {
  // Resolved lazily, never in the constructor: the `Router` builds its own `TitleStrategy`, so
  // asking for the router here — or for `PageTitleService`, which reaches the router through
  // `DetailTitleService` — closes a cycle back onto a strategy that is still being constructed.
  // By the time `updateTitle` runs, both exist.
  #injector = inject(Injector);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.#injector.get(PageTitleService);
    pageTitle.routeTitleKey.set(this.buildTitle(snapshot));
    pageTitle.navId.set(currentNavId(this.#injector.get(Router)));
  }
}
